// extracted by mini-css-extract-plugin
export default {"description":"giveaway-landing-description__description___Dm79i","emptyDescription":"giveaway-landing-description__emptyDescription___osdVT"};